import React from 'react';
import {Row, Col, Card, Typography, Space} from 'antd';
import './roles.scss';

const {Title, Text} = Typography;

interface StatItem {
	number: string;
	title: string;
}

const statItems: StatItem[] = [
	{
		number: '14,000+',
		title: 'Vetted Candidates & growing fast',
	},
	{
		number: '$50m+',
		title: 'Annual client savings',
	},
	{
		number: '300+',
		title: 'Businesses helped',
	},
	{
		number: '600+',
		title: 'Job ads posted',
	},
];

export default function PermworksByTheNumbers() {
	return (
		<div className="py-14 bg-white pb-20 ">
			<div className="max-w-[1100px] mx-auto px-4">
				<h3 className="text-darkCharcoal font-normal text-xl sm:text-2xl text-center mb-8">Permworks by the numbers</h3>

				<Row gutter={[24, 24]} justify="center">
					{statItems.map((item, index) => (
						<Col xs={24} sm={12} md={6} key={index}>
							<Card className="text-left h-full">
								<Space direction="vertical" size="small" className="w-full">
									<div className="font-medium text-xl text-deepBlue">{item.number}</div>
									<div className="text-darkCharcoal font-medium text-base m-0">{item.title}</div>
								</Space>
							</Card>
						</Col>
					))}
				</Row>

				{/* <Row className="mt-12" justify="center" gutter={[24, 24]}>
					<Col xs={24} className="text-center">
						<Space size="large" className="flex justify-center flex-wrap">
							<img src="/images/logos/logo1.png" alt="Partner logo" className="h-12 opacity-70" />
							<img src="/images/logos/logo2.png" alt="Partner logo" className="h-12 opacity-70" />
							<img src="/images/logos/logo3.png" alt="Partner logo" className="h-12 opacity-70" />
							<img src="/images/logos/logo4.png" alt="Partner logo" className="h-12 opacity-70" />
							<img src="/images/logos/logo5.png" alt="Partner logo" className="h-12 opacity-70" />
						</Space>
					</Col>
				</Row> */}
			</div>
		</div>
	);
}
